import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import { ReferenceService } from '../../generated/auth/services/reference.service';
import {
  loadPartnerCodes,
  loadPartnerCodesFailure,
  loadPartnerCodesSuccess,
  togglePartnerCodesLoading,
} from './partner-codes.actions';

@Injectable()
export class PartnerCodesEffects {
  private actions$ = inject(Actions);
  private referenceService = inject(ReferenceService);

  constructor() {}

  // loadPartnerCodes$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(loadPartnerCodes),
  //     switchMap(() =>
  //       this.referenceService.referenceSasSecLookupGetPartnerCodesGet().pipe(
  //         map((response) => loadPartnerCodesSuccess({ partnerCodes: response.result || [] })),
  //         catchError((error) => of(loadPartnerCodesFailure({ error }))),
  //       ),
  //     ),
  //   ),
  // );

  toggleLoading$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadPartnerCodes),
      map(() => togglePartnerCodesLoading({ loading: true })),
    ),
  );

  stopLoading$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadPartnerCodesSuccess, loadPartnerCodesFailure),
      map(() => togglePartnerCodesLoading({ loading: false })),
    ),
  );
}
